<template>
  <div class="managerUserOrderView">
    <view-frame :titleObject="titleObject" :buttonObj="buttonObj">
      <template #rightBtn="scope">
        <template v-if="custName && custName.member_actions && custName.member_actions.default_actions">
          <el-button v-show="item.action !== 'view'" v-for="(item, index) in custName.member_actions.default_actions" :key="'default_actions' + index" :type="item.type && item.type === 'warn' ? 'danger' : 'primary'" size="mini" @click="handleClick(item, scope.row)">{{item.name}}</el-button>
        </template>
        <template v-if="custName && custName.member_actions && custName.member_actions.custom_actions">
          <el-button v-for="(item, index) in custName.member_actions.custom_actions" :key="'custom_actions' + index" :type="item.type && item.type === 'warn' ? 'danger' : 'primary'" size="mini" @click="handleCusClick(item)">{{item.name}}</el-button>
        </template>
      </template>
      <template>
        <el-card>
          <el-row>
            <el-col :span="24">
            <span class="view__text">{{$t('form.product.basicMsg')}}</span>
            <el-card class="animate__animated animate__fadeInDown" shadow="hover">
              <custome-table tableType="object" :custSpan="6" :data="custName.basic_information" :dataItem="basicInformation"></custome-table>
            </el-card>
            </el-col>
          </el-row>
        </el-card>
        <el-card class="margintop20">
          <el-row>
            <el-col :span="24">
              <span class="view__text">{{$t('form.common.changeHistory')}}</span>
              <el-card class="animate__animated animate__fadeInUp" shadow="hover">
                 <span class="view__text"></span>
                 <createTable :autoWidth="true" :tableDataItem="historyTableItem" :operateVisible="false" :tableData="historyTableData"></createTable>
              </el-card>
            </el-col>
          </el-row>
        </el-card>
      </template>
    </view-frame>
    <dialogEffect v-if="dialogVisible" :opereteDate="false" :todayVisible="true" :dialogVisible.sync="dialogVisible" :data="dialogData" @doNextConfirm="doNextConfirm" @cancle="search" :cancelVisible="false"></dialogEffect>
  </div>
</template>

<script>
import loading from '@/utils/loading.json'
import { getMemberApplyDetails, getUserGroupByUserType } from '@/services/members'
import { getCompanySimpleList } from '@/services/setting.js'
import history from '@/common/data/jsonData'
import { getHistoryList } from '@/services/resource'
import createTable from '@/components/createTable'
import viewFrame from '@/components/viewFrame'
import customeTable from '@/components/customeTable'
import dialogEffect from '@/components/dialogEffect'
import jsonData from './jsonData'
import { mixin } from '@/mixins/mixin'
export default {
  name: 'memberDetail',
  components: {
    createTable,
    viewFrame,
    customeTable,
    dialogEffect
  },
  mixins: [mixin],
  data () {
    return {
      validateVisible: false,
      buttonObj: [],
      titleObject: {},
      custName: {},
      formData: {},
      modifyData: {},
      type: '',
      userGroups: [],
      companies: [],
      tableDataViewItem: jsonData.tableDataViewItem,
      historyTableItem: history.historyTableItem,
      basicInformation: jsonData.basicInformation,
      historyTableData: [],
      cancelRefresh: false
    }
  },
  beforeRouteLeave (to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    this.validateVisible = false
    next()
  },
  created () {
    this.init()
  },
  activated () {
  },
  methods: {
    // 初始化
    async init () {
      this.$store.state.app.loading = this.$loading(loading)
      this.getData()
      const res = await getMemberApplyDetails(this.$route.params.id)
      if (res.status === 200) {
        this.custName = res.data.user
        Object.assign(this.titleObject, { title: this.$t('form.members.memberName') + this.$t('text.symbol'), data: this.custName.user_name ? this.custName.user_name : '-' })
      }
      this.$store.state.app.loading.close()
      this.getDetail()
    },
    getDetail () {
      //  获取历史操作
      getHistoryList({ item_type: 'User', item_id: this.$route.params.id }).then(res => {
        if (res.status === 200) {
          this.historyTableData = res.data.versions
        }
      })
    },
    async dialogSearch () {
      this.init()
      if (!this.cancelRefresh) {
        this.showMemberInformationDialog()
      }
    },
    showMemberInformationDialog () {
      const dialogData = {
        extra_params: [{
          hint: this.$t('form.members.creditLimit'),
          name: this.$t('form.members.billTip'),
          type: 'tip'
        }, {
          hint: this.$t('form.members.creditLimit'),
          key: 'credit_limit_f',
          optional: false,
          name: this.$t('form.members.creditLimit'),
          type: 'text'
        }, {
          hint: this.$t('form.members.billingCycle'),
          key: 'billing_cycle_mode',
          optional: false,
          name: this.$t('form.members.billingCycle'),
          type: 'select',
          options: [{
            name: this.$t('form.members.daily'),
            value: 'daily'
          }, {
            name: this.$t('form.members.anotherDay'),
            value: 'every_other_day'
          }, {
            name: this.$t('form.members.weekly'),
            value: 'weekly'
          }, {
            name: this.$t('form.members.monthly'),
            value: 'monthly'
          }]
        }, {
          hint: this.$t('form.members.userGroup'),
          key: 'user_group_id',
          optional: false,
          name: this.$t('form.members.userGroup'),
          type: 'select',
          options: this.userGroups,
          option_key: 'id',
          option_value: 'id'
        }, {
          hint: this.$t('form.members.company'),
          key: 'client_company_id',
          optional: false,
          name: this.$t('form.members.company'),
          type: 'select',
          options: this.companies,
          option_key: 'id',
          option_value: 'id'
        }, {
          hint: this.$t('form.members.password'),
          key: 'password',
          optional: false,
          name: this.$t('form.members.password'),
          type: 'text'
        }],
        parentParams: 'user',
        method: 'PUT',
        path: `/users/${this.$route.params.id}`
      }
      this.batchData = dialogData
      this.dialogData = dialogData.extra_params
      this.dialogVisible = true
      this.cancelRefresh = true
    },
    getData () {
      getUserGroupByUserType('wholesale').then(res => {
        this.userGroups = res.data.user_groups
      })
      getCompanySimpleList().then(res => {
        this.companies = res.data.companies
      })
    },
    search () {},
    gobackRouter () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scope>
.managerUserOrderView {
  .del-oder-item-dialog-body {
    .heder {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      .avatar {
        flex-shrink: 0;
      }
    }
    .info-box {
      margin-left: 12px;
      margin-bottom: -12px;
      .title {
        margin-bottom: 12px;
      }
    }
    .notice {
      margin-bottom: 12px;
    }
  }
}
</style>
